import { render } from "./articlesPage.vue?vue&type=template&id=3346b264"
import script from "./articlesPage.vue?vue&type=script&lang=js"
export * from "./articlesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__